export default function objectOmitNull(obj: {[key: string]: any}): {[key: string]: any} {
  for (var propName in obj) {
    if (obj[propName] == null) {
      delete obj[propName];
    }
  }
  return obj;
}
